module.exports = __webpack_public_path__ + "img/arrowUp.870e73e0.svg";